<template>
  <div id="new-group" class="box" style="padding: 20px;">
    <vue-loading :active.sync="isSaving" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>

    <transition name="fade" appear>
      <div>
        <h4>Delete {{id}} Group</h4>
        <button class="btn btn-danger" @click="delGroup()">Delete Group</button>
      </div>
    </transition>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import VueLoading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'

export default {
  name: 'GroupDelete',
  components: {
    VueLoading
  },
  props: [
    'id'
  ],
  computed: {
    ...mapGetters([
      'contracts',
      'groups'
    ])
  },
  data () {
    return {
      isSaving: false
    }
  },
  watch: {
    id: function () {
      if (this.contracts.includes(this.id)) {
        this.$router.push({ name: 'ContractDelete', params: { id: this.id } })
      } else if (!this.groups.includes(this.id)) {
        this.$router.push({ name: 'Home' })
      }
    }
  },
  methods: {
    delGroup: function () {
      this.isSaving = true
      if (confirm('Are you sure you want to delete the group "' + this.id + '" from the base2 portal?')) {
        HTTP.delete(`/management/group/${this.id}`)
          .then(() => {
            this.flashMessage.success({
              message: 'Successfully deleted group ' + this.id
            })
          })
          .catch((error) => {
            this.flashMessage.error({
              message: 'Failed to delete group ' + error.message
            })
          })
          .finally(() => {
            this.isSaving = false
          })
      }
    }
  }
}
</script>

<style scoped src='../assets/stylesheet/transitions.css'></style>



// WEBPACK FOOTER //
// src/views/GroupDelete.vue